import React from 'react';
import { UploadButtonProps } from './types';
import { Button, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const UploadButton = ({
  id,
  onClick,
  buttonText,
  isArrowDown,
  disabled,
  icon: Icon,
}: UploadButtonProps) => {
  return (
    <Button
      id={`${id ?? 'uploadButton'}`}
      disabled={disabled}
      sx={{ zIndex: 10 }}
      variant='text'
      className='upload-button'
      onClick={onClick}
    >
      {Icon ? (
        <Icon id={`${id ?? 'uploadButton'}CustomIcon`} className='upload-file-icon' />
      ) : (
        <UploadFileIcon id={`${id ?? 'uploadButton'}UploadFileIcon`} className='upload-file-icon' />
      )}
      <Typography id={`${id ?? 'uploadButton'}Text`} className='button-text'>
        {buttonText}
      </Typography>
      {isArrowDown && (
        <KeyboardArrowDownIcon
          id={`${id ?? 'uploadButton'}KeyboardArrowDownIcon`}
          className='arrowdown-icon'
        ></KeyboardArrowDownIcon>
      )}
    </Button>
  );
};

export default UploadButton;
